export enum SCAN_STATUS {
  SCAN_FAILED = 'SCAN_FAILED',
  SCAN_RUNNING = 'SCAN_RUNNING',
  SCAN_SUCCESSFUL = 'SCAN_SUCCESSFUL',
  UPLOAD_FAILED = 'UPLOAD_FAILED'
}

export enum DOCUMENT_TYPE {
  TRAVEL_POLICY = 'travel_policy'
}
